import { render, staticRenderFns } from "./OrderProductsListForm.vue?vue&type=template&id=2f5cfa09&scoped=true&"
import script from "./OrderProductsListForm.vue?vue&type=script&lang=js&"
export * from "./OrderProductsListForm.vue?vue&type=script&lang=js&"
import style0 from "./OrderProductsListForm.vue?vue&type=style&index=0&id=2f5cfa09&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5cfa09",
  null
  
)

export default component.exports